// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"93588204","402":"f105b598","614":"cabd8b7d","647":"3cae247b","768":"32adbc32","787":"cf733e01","798":"f894ea42","808":"521ac23e","870":"409770b7"}[chunkId] + ".chunk.js";
};